// extracted by mini-css-extract-plugin
module.exports = {"container":"EditCompWrap_container__3EUJi","targetStyle":"EditCompWrap_targetStyle__mtvks","deleteStyle":"EditCompWrap_deleteStyle__pBATY"};